<script>
import FormInput from "@/components/forms/FormInput.vue"
import FormSelect from "@/components/forms/FormSelect.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  name: "TransformationFunctionDefinition",
  components: { FormSelect, FormInput },
  props: {
    transformationFunction: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup() {
    const projectStore = useProjectStore()
    return { projectStore }
  },
  data() {
    return {
      transformationDefinitionTypeOptions: [
        { text: "Groovy", value: "GROOVY" },
        { text: "Javascript", value: "JAVASCRIPT" }
      ]
    }
  },
  computed: {
    transformationTypeOptions() {
      return [
        { text: this.$t("IN_TRANSFORMATION"), value: "IN" },
        { text: this.$t("PAYLOAD_TRANSFORMATION"), value: "PAYLOAD" },
        { text: this.$t("DATAFLOW_TRANSFORMATION"), value: "DATAFLOW" },
        { text: this.$t("OUT_TRANSFORMATION"), value: "OUT" }
      ]
    },
    transformationSubTypeOptions() {
      return [
        { text: this.$t("lora"), value: "LORA" },
        { text: this.$t("MQTT"), value: "MQTT" },
        { text: this.$t("HTTP"), value: "HTTP" },
        { text: this.$t("UDP"), value: "UDP" }
      ]
    }
  }
}
</script>

<template>
  <div>
    <div class="d-flex flex-wrap justify-content-around">
      <FormInput
        :disabled="readOnly"
        :label="$t('TITLE')"
        :placeholder="$t('TRANSFORMATION_FUNCTION_TITLE_PLACEHOLDER')"
        :value="transformationFunction.label"
        class="mb-4 w-50"
        side-box
        @input="transformationFunction.label = $event"
      />
      <FormInput
        :disabled="readOnly"
        :label="$t('DESCRIPTION')"
        :placeholder="$t('TRANSFORMATION_FUNCTION_DESCRIPTION_PLACEHOLDER')"
        :value="transformationFunction.description"
        class="mb-4 w-50"
        sideBox
        @input="transformationFunction.description = $event"
      />
      <FormSelect
        :disabled="readOnly"
        :items="transformationTypeOptions"
        :label="$t('TF_TYPE')"
        :value="transformationTypeOptions.find((tf) => tf.value === transformationFunction.type)"
        class="mb-3 w-50"
        item-text="text"
        item-value="value"
        side-box
        @change="transformationFunction.type = $event.value"
      />
      <FormSelect
        :disabled="readOnly"
        :items="transformationSubTypeOptions"
        :label="$t('SUB_TYPE')"
        :value="transformationSubTypeOptions.find((tf) => tf.value === transformationFunction.subType)"
        class="mb-3 w-50"
        item-text="text"
        item-value="value"
        side-box
        @change="transformationFunction.subType = $event.value"
      />
      <FormSelect
        :disabled="readOnly"
        :items="transformationDefinitionTypeOptions"
        :value="transformationDefinitionTypeOptions.find((tf) => tf.value === transformationFunction.definitionType)"
        class="mb-3 w-50"
        item-text="text"
        item-value="value"
        label="Interpret"
        side-box
        @change="transformationFunction.definitionType = $event.value"
      />
      <FormSelect
        :disabled="readOnly"
        :items="projectStore.projectList || []"
        :label="$t('project')"
        :value="projectStore.projectList.find((p) => p.projectId === transformationFunction.projectId)"
        class="mb-3 w-50"
        item-text="projectName"
        item-value="projectId"
        side-box
        @change="transformationFunction.projectId = $event.projectId"
      />
    </div>
  </div>
</template>
